import { StateCreator } from 'zustand';

import {
  handleAppendActivityLogs,
  handleClearEntry,
  handleInitEntry,
  handlePrependActivityLog,
  handleSetActivityLogs,
  handleSetError,
  handleSetLoading,
  handleSetLoadingMore,
} from './handlers';
import {
  HandlerSet,
  InboxEntryActivityLogsState,
  InboxEntryActivityLogsStore,
} from './types';

export const INITIAL_ACTIVITY_LOGS_STATE: InboxEntryActivityLogsState = {
  stateByEntry: {},
};

export const createInboxEntryActivityLogsSlice: StateCreator<
  InboxEntryActivityLogsStore
> = (set) => {
  const handlerSet: HandlerSet = (updater) => {
    if (typeof updater === 'function') {
      set(
        (fullState) =>
          updater(fullState) as Partial<InboxEntryActivityLogsStore>,
      );
    } else {
      set(updater as Partial<InboxEntryActivityLogsStore>);
    }
  };

  return {
    ...INITIAL_ACTIVITY_LOGS_STATE,

    initEntry: (inboxEntryId) => handleInitEntry(handlerSet, inboxEntryId),
    clearEntry: (inboxEntryId) => handleClearEntry(handlerSet, inboxEntryId),
    setActivityLogs: (inboxEntryId, logs, exclusiveStartKey) =>
      handleSetActivityLogs(handlerSet, inboxEntryId, logs, exclusiveStartKey),
    appendActivityLogs: (inboxEntryId, logs, exclusiveStartKey) =>
      handleAppendActivityLogs(
        handlerSet,
        inboxEntryId,
        logs,
        exclusiveStartKey,
      ),
    prependActivityLog: (inboxEntryId, log) =>
      handlePrependActivityLog(handlerSet, inboxEntryId, log),
    setLoading: (inboxEntryId, isLoading) =>
      handleSetLoading(handlerSet, inboxEntryId, isLoading),
    setLoadingMore: (inboxEntryId, isLoadingMore) =>
      handleSetLoadingMore(handlerSet, inboxEntryId, isLoadingMore),
    setError: (inboxEntryId, error) =>
      handleSetError(handlerSet, inboxEntryId, error),
    resetState: () => set(INITIAL_ACTIVITY_LOGS_STATE),
  };
};
